import styled from 'styled-components'

import { COLORS, typography } from '../../styles'

const Styled = styled.div`
  display: inline-block;
  height: 3.2rem;
  user-select: none;
`
Styled.container = styled.div`
  position: relative;
  display: inline-block;
  height: 3.2rem;
  user-select: none;
`
Styled.unit = styled.div`
  ${typography({
    fontFamily: ['Viksjow', 'Surt', 'sans-serif'],
    fontSize: '1.7rem',
    lineHeight: '3.2rem',
  })};
  position: absolute;
  inset: 0;
  width: 100%;
  height: 3.2rem;
  color: ${({ textColor }) => textColor || COLORS.white};
  text-align: center;
  display: inline-block;
  user-select: none;
`
Styled.unitPart = styled.span`
  display: inline;
  opacity: ${({ isActive }) => (isActive ? 1 : 0.2)};
  user-select: none;
`

export default Styled
